import React, { useEffect, useState } from 'react'
import { css, Flex } from 'theme-ui'
import Link from '../../components/shared/Typography/Link/Link'
import Body from '../../components/shared/Typography/Body/Body'
import { Window } from '../../utils'
import { Global } from '@emotion/core'

const ShowGorgias = css`
  .css-sef6vt {
    display: block !important;
  }
`

const HideGorgias = css`
  .css-sef6vt {
    display: none !important;
  }
`

export const GorgiasButton = ({ render }) => {
  const [showGorgias, setGorgias] = useState(false)

  useEffect(() => {
    if (Window && window.GorgiasChat && window.GorgiasChat.isOpen()) {
      setGorgias(true)
    } else {
      setGorgias(false)
    }
  })

  function setShowGorgias() {
    setGorgias(true)
    Window && window.GorgiasChat && window.GorgiasChat.open()
  }

  return (
    <>
      {showGorgias ? (
        <Global styles={ShowGorgias} />
      ) : (
        <Global styles={HideGorgias} />
      )}
      {render({ setShowGorgias })}
    </>
  )
}

const ColumnLink = props => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Body
        as="h6"
        variant="body2bold"
        sx={{
          textTransform: 'uppercase',
          textAlign: 'left',
          mb: '20px',
        }}
      >
        {props.title}
      </Body>
      {props.links.map((l, index) => {
        const startsWithHash = l.navLinkSlug.startsWith('#')
        if (l.navLinkSlug.startsWith('#rp-')) {
          return (
            <GorgiasButton
              render={({ setShowGorgias }) => (
                <li key={index}>
                  <Link
                    linkProps={{
                      id:
                        (startsWithHash && `${l.navLinkSlug.split('#')[1]}`) ||
                        `footer-link-${index}`,
                      ...(l.navLinkSlug.startsWith('#rp-') && {
                        onClick: () => {
                          setShowGorgias()
                        },
                      }),
                    }}
                    sx={{
                      textAlign: 'left',
                      wordSpacing: '0px',
                    }}
                    variant="footerColumnText"
                    newRoute={true}
                    to={!startsWithHash ? l.navLinkSlug : undefined}
                    color={l.color}
                  >
                    {l.navLinkText}
                  </Link>
                </li>
              )}
            />
          )
        }
        return (
          <li key={index}>
            <Link
              linkProps={{
                id:
                  (startsWithHash && `${l.navLinkSlug.split('#')[1]}`) ||
                  `footer-link-${index}`,
              }}
              sx={{
                textAlign: 'left',
                wordSpacing: '0px',
              }}
              variant="footerColumnText"
              newRoute={true}
              to={!startsWithHash ? l.navLinkSlug : undefined}
              color={l.color}
            >
              {l.navLinkText}
            </Link>
          </li>
        )
      })}
    </Flex>
  )
}

export default ColumnLink
